import { FormattedMessage, useIntl } from "react-intl";

import { RanaHeading } from "@nens/ranalib";
import { RanaPageTitle } from "@nens/ranalib";

import { BasePage } from "@/components/base-page";
import { AdminTenantList } from "@/features/admin";
import { RanaTabs } from "@/lib/rana-tabs";
import { useInstancePermissions } from "@/queries/query-instance-permissions";

export function AdminPage() {
  const intl = useIntl();
  const { canListTenant } = useInstancePermissions();

  const ADMIN_TABS = {
    tenants: {
      title: <FormattedMessage id="tab.tenants" defaultMessage="Tenants" />,
      panel: canListTenant ? (
        <>
          <RanaPageTitle
            showTenant
            subTitle={intl.formatMessage({
              id: "page_title.settings.users",
              defaultMessage: "Users",
            })}
          />
          <AdminTenantList />
        </>
      ) : null,
    },
    identityProviders: {
      title: <FormattedMessage id="tab.identity_providers" defaultMessage="Identity Providers" />,
      panel: null,
    },
    threediOrganisations: {
      title: (
        <FormattedMessage id="tab.threedi_organisations" defaultMessage="Rana HCC organisations" />
      ),
      panel: null,
    },
  } as const;
  return (
    <BasePage pageSubTitle={"admin"} activeSidebarButton="admin">
      <RanaHeading type="h1" addDot>
        <FormattedMessage id="heading.admin" defaultMessage="Admin" />
      </RanaHeading>
      <RanaTabs isPageNav tabs={ADMIN_TABS} tabKey="tabs" />
    </BasePage>
  );
}
